import React from 'react';
import PropTypes from 'prop-types';

const ContasForm = (props) => {
    return (
        <div className="row">
            <div className="form-group col">
                <input type="text" placeholder="Conta..." className="form-control"
                    value={props.conta.nome} autoFocus data-test="nome" aria-label="Nome da conta"
                    onChange={evt => props.handleChangeNome(evt)} />
            </div>

            <div className="form-group col-2">
                <button type="button" className="btn btn-primary btn-block"
                    onClick={props.handleSave} alt="Salvar" >
                    <i className="far fa-save" title="Salvar" />
                </button>
            </div>
        </div>
    );
};

ContasForm.propTypes = {
    handleSave: PropTypes.func.isRequired,
    handleChangeNome: PropTypes.func.isRequired,
    handleChangeVisibilidade: PropTypes.func.isRequired,
    conta: PropTypes.object.isRequired,
};

export default ContasForm;


// WEBPACK FOOTER //
// ./src/components/contas/ContasForm.js